<template>
  <section class="table-section disp-scroll">
    <table class="robo-list-table" border="1">
      <tr class="table-header">
        <th class="roboname">ロボ名</th>
        <th class="detail">会話詳細</th>
        <th class="created-at">会話日時</th>
      </tr>
      <template v-for="(message, index) in uniqueByRoboname" v-bind:index="index">
        <tr :key="message.id">
          <td class="roboname">
            {{message.name}}
          </td>
          <td>
            <div class="center-item-wrapper">
              <button class="button is-small"
                @click="clickDetailButton(message)">
                確認
              </button>
            </div>
          </td>
          <td>{{formatTime(message.from)}}～{{formatTime(message.to)}}</td>
        </tr>
      </template>
    </table>
  </section>
</template>

<script>
export default {
  props: {
    messageList: {
      type: Array,
      required: false,
    },
  },
  computed: {
    uniqueByRoboname(){
      const roboNameList = [];
      const prevRoboName = [];
      var roboName = "";
      var createdAtFrom = new Date();
      var createdAtTo = new Date();

      this.messageList.forEach(function (roboname) {
        if (prevRoboName[0] !== roboname.name && roboname.speaker === "my") {
          if (roboName !== "") {
            const index = roboNameList.findIndex((el) => el.name === roboName)
            if (index === -1) {
              roboNameList.push({name: roboName, from: createdAtFrom, to: createdAtTo});
            } else {
              roboNameList.splice(index, 1, {name: roboNameList[index].name, from: roboNameList[index].from, to: createdAtTo})
            }
          }

          roboName = roboname.name
          createdAtFrom = roboname.createdAt
          createdAtTo = roboname.createdAt
          prevRoboName[0] = roboname.name
        } else {
          createdAtTo = roboname.createdAt
        }
      }); 

      if (roboName !== "") {
        const index = roboNameList.findIndex((el) => el.name === roboName)
        if (index === -1) {
          roboNameList.push({name: roboName, from: createdAtFrom, to: createdAtTo});
        } else {
          roboNameList.splice(index, 1, {name: roboNameList[index].name, from: roboNameList[index].from, to: createdAtTo})
        }
      }

      const roboNameList2 = roboNameList.sort((a,b) => {
        return (a.to < b.to) ? -1 : (a.to > b.to) ? 1 : 0;
      })

      return roboNameList2.slice().reverse();
   }
  },
  methods: {
    formatTime (createdAt) {
      return this.$moment(createdAt).format('YYYY/MM/DD H:mm:ss')
    },
    clickDetailButton (message) {
      this.$emit('clickDetailButton', message)
    }
  },
}
</script>

<style lang="scss" scoped>
.table-section {
  //overflow: auto;
}
.table-section::-webkit-scrollbar {
  //width: 5px;
}
.robo-list-table {
  font-size: 12px;
  width: 100%;
  table-layout: fixed;
  th, td {
    padding: 8px;
  }
  .roboname {
    width: 200px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .detail {
    width: 64px;
  }
  .created-at {
    width: 200px;
  }
  .check {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .center-item-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.empty-tr {
  height: 36px;
}
td {
  word-wrap: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/tables/MessageListTable.vue